import { getSuspensionRules } from 'ducks/suspensionRules';
import { connect } from 'react-redux';
import SuspensionRuleList from './SuspensionRuleList';

const mapStateToProps = (state) => ({
  rules: state.suspensionRules.rules,
  ajaxStatus: state.ajax,
  localisation: state.localisation,
  appLoading: state.meta.appLoading,
});

const mapDispatchToProps = {
  getSuspensionRules,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuspensionRuleList);
